import React from 'react';
import { withTranslation } from 'react-i18next';
import { withStyles } from '@material-ui/styles';
import MbSelectbox from 'components/molecules/MbSelectbox';

const styles = () => ({});

/**
 * option 리스트 만들어주는 함수
 * @param {Array} data option list 만들 array
 * @param {string} optionLabelKey option에 나올 label key 값
 * @param {string} optionValueKey option value key 값
 */
const makeOptionList = (data, optionLabelKey, optionValueKey) => {
  if (typeof data === 'undefined') {
    return [];
  }
  const result = [...data];
  const defaultOption = {
    [optionLabelKey]: '알수없음',
    [optionValueKey]: null,
  };
  if (data.length === 0) {
    result.push(defaultOption);
  }

  return result;
};

class PayTypeSelectBox extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      codeId: this.props.defaultCodeId,
      filterList: [],
    };
  }

  shouldComponentUpdate(nextProps, nextState) {
    const { defaultCodeId } = nextProps;
    if (defaultCodeId !== this.state.codeId) {
      return true;
    } else {
      return false;
    }
  }

  /**
   * selectbox 필터 선택
   * @param {string} name
   * @param {*} value
   */
  handleFilterChange = (name, index) => {
    this.props.handleOnchangeFilter(this.props.orderNumber, index);
  };

  render() {
    const { handleFilterChange } = this;
    const { t, classes, filterList = [], label } = this.props;
    const { codeId } = this.state;
    return (
      <div className={classes.root}>
        <MbSelectbox
          label={t(label)}
          value={codeId}
          name="codeDesc"
          optionData={makeOptionList(filterList, 'CODE_DESC', 'CODE_ID')}
          optionLabelKey="CODE_DESC"
          optionValueKey="CODE_ID"
          handleOnchange={handleFilterChange}
          icon={false}
        />
      </div>
    );
  }
}

export default withTranslation()(withStyles(styles)(PayTypeSelectBox));
